import { createFeature, createReducer, on } from '@ngrx/store';
import { EventsActions } from '../actions/events.actions';
import { ErrorStore, Event } from '@sleipai/sleip-models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const eventsStoreFeatureKey = 'events';

export interface State extends EntityState<Event> {
  loaded: boolean;
  loading: boolean;
  error: ErrorStore | null;
}

export const adapter: EntityAdapter<Event> = createEntityAdapter<Event>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export const reducer = createReducer(
  initialState,
  on(EventsActions.loadEventsListForHorse, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(EventsActions.loadEventsListForHorseSuccess, (state, { events }) => {
    return adapter.upsertMany(events, {
      ...state,
      loading: false,
      loaded: true,
    });
  }),
  on(EventsActions.loadEventsListForHorseFailure, (state, { error }) => {
    return {
      ...state,
      loaded: true,
      loading: false,
      error: {
        message: error['message'],
        status: error['status'],
      },
    };
  })
);

export const eventsStoreFeature = createFeature({
  name: eventsStoreFeatureKey,
  reducer,
});

export const {
  selectIds: selectEventsEntitiesIdsAdapter,
  selectEntities: selectEventsEntitiesAdapter,
  selectAll: selectAllEventsAdapter,
  selectTotal: selectEventsTotalAdapter,
} = adapter.getSelectors();
